class ProductGroupNavController {
    constructor(productGroupService, offerGroupService) {
        this.productGroupService = productGroupService;
        this.offerGroupService = offerGroupService;
    }

    $onInit() {
        this.groupService = this.groupType === 'OfferGroup' ? this.offerGroupService : this.productGroupService;
    }

    isGroupLoading() {
        return this.groupService.selectedGroup === undefined;
    }

    isCountLoading() {
        return this.groupService.selectedGroupTotalCount === undefined;
    }
}

ProductGroupNavController.$inject = ['ProductGroupService', 'OfferGroupService'];

const productGroupNavComponentDefinition = {
    bindings: {
        groupType: '=',
    },
    controller: ProductGroupNavController,
    template: require('./productgroup-nav.component.html').trim(),
};

module.exports = {
    ProductGroupNavController,
    productGroupNavComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/productgroups/productgroup-nav.component.js